import React, { useState, useEffect } from 'react';
import './Services.css';

const Services = () => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    // Static data for now - will connect to backend later
    const staticServices = [
      {
        id: 1,
        title: 'Mobile App Development',
        description:
          'Native and cross-platform mobile applications for iOS and Android.',
        details:
          'We design and build high-performance mobile apps using React Native, Flutter, and native technologies. Our team handles everything from UX flows and UI design to API integration, push notifications, app store deployment, and ongoing updates so your app stays fast, secure, and compatible with the latest OS versions.',
        icon: '📱',
      },
      {
        id: 2,
        title: 'Web Development',
        description:
          'Modern, responsive websites and web applications.',
        details:
          'From landing pages to complex dashboards, we create pixel-perfect, responsive web experiences using React and other modern frameworks. We focus on speed, SEO, accessibility, and clean architecture so your website looks great, loads fast, and is easy to maintain and scale as your business grows.',
        icon: '🌐',
      },
      {
        id: 3,
        title: 'Software Development',
        description:
          'Custom desktop and enterprise software tailored to your business.',
        details:
          'We analyze your workflows and pain points to design bespoke software that automates processes, connects data sources, and improves productivity. Our engineers follow best practices for security, performance, and reliability to deliver robust applications that fit seamlessly into your existing ecosystem.',
        icon: '💻',
      },
      {
        id: 4,
        title: 'UI/UX Design',
        description:
          'Beautiful, intuitive interfaces and user experiences.',
        details:
          'Our design team creates user journeys, wireframes, and high-fidelity prototypes that are both visually stunning and easy to use. We focus on clarity, usability, and brand consistency to ensure every screen guides users naturally toward their goals and leaves a lasting impression.',
        icon: '🎨',
      },
      {
        id: 5,
        title: 'Cloud Solutions',
        description:
          'Scalable cloud infrastructure and deployment solutions.',
        details:
          'We architect and manage cloud environments on AWS, Azure, and Google Cloud. This includes setting up secure VPCs, auto-scaling, managed databases, backups, monitoring, and cost optimization so your applications stay available, resilient, and efficient under any load.',
        icon: '☁️',
      },
      {
        id: 6,
        title: 'Consulting Services',
        description:
          'Expert guidance for your technology decisions.',
        details:
          'Our consultants help you choose the right tech stack, define architecture, and plan roadmaps. We review existing systems, identify risks and bottlenecks, and propose pragmatic improvements so you can invest confidently and avoid costly rework later.',
        icon: '🤝',
      },
      {
        id: 7,
        title: 'Digital Marketing',
        description:
          'Performance-focused campaigns across SEO, SEM, and social.',
        details:
          'We plan and run data-driven digital marketing campaigns across Google Ads, social media, and other channels. Our team sets up tracking, optimizes creatives and landing pages, and continuously refines targeting to improve ROI and bring in high-quality leads.',
        icon: '📈',
      },
      {
        id: 8,
        title: 'SEO & Content Strategy',
        description:
          'Increase organic visibility and attract the right audience.',
        details:
          'We perform keyword research, on-page optimization, and technical SEO audits to improve your rankings. Paired with a long-term content strategy, this helps your brand appear for relevant searches and positions you as an authority in your niche.',
        icon: '🔍',
      },
      {
        id: 9,
        title: 'DevOps & CI/CD',
        description:
          'Automated build, test, and deployment pipelines.',
        details:
          'We implement CI/CD pipelines and DevOps practices that automate testing, deployment, and infrastructure provisioning. This reduces manual effort, speeds up release cycles, and makes rollbacks and environment management far more reliable.',
        icon: '⚙️',
      },
      {
        id: 10,
        title: 'Quality Assurance & Testing',
        description:
          'Manual and automated testing for stable releases.',
        details:
          'Our QA engineers create detailed test plans, execute manual and automated tests, and integrate testing into your CI pipeline. We focus on functional, regression, performance, and security testing so you can ship features with confidence.',
        icon: '✅',
      },
      {
        id: 11,
        title: 'Maintenance & Support',
        description:
          'Ongoing monitoring, fixes, and enhancements.',
        details:
          'We provide long-term maintenance for your applications, including bug fixes, security patches, performance improvements, and small feature enhancements. Proactive monitoring lets us catch issues early and keep your systems running smoothly 24/7.',
        icon: '🛠️',
      },
      {
        id: 12,
        title: 'Automation Solutions',
        description:
          'End-to-end automation for business processes and workflows.',
        details:
          'We design and implement automation across your organization using tools like RPA, workflow engines, and custom scripts. From automating repetitive back-office tasks and approvals to integrating systems through APIs, our automation solutions reduce manual work, minimize errors, and free your team to focus on high-value activities.',
        icon: '🤖',
      },
    ];
    setServices(staticServices);
    setSelectedService(staticServices[0]);
  }, []);

  const handleSelectService = (service) => {
    setSelectedService(service);
    const detailsSection = document.getElementById('service-details');
    if (detailsSection) {
      detailsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  return (
    <section id="services" className="section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service) => (
            <button
              key={service.id}
              type="button"
              className={`service-card${
                selectedService && selectedService.id === service.id
                  ? ' service-card--active'
                  : ''
              }`}
              onClick={() => handleSelectService(service)}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <span className="service-cta">View details</span>
            </button>
          ))}
        </div>

        {selectedService && (
          <div id="service-details" className="service-details">
            <h3 className="service-details-title">
              <span className="service-details-icon">
                {selectedService.icon}
              </span>
              {selectedService.title}
            </h3>
            <p className="service-details-text">{selectedService.details}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
